import React from "react";
import Reveal from "../Reveal";
import SpotlightCard from "../SpotlightCard";

const LINKS = [
  {
    icon: "fa-regular fa-envelope",
    label: "joshapascual@gmail.com",
    href: "mailto:joshapascual@gmail.com",
  },
  {
    icon: "fa-brands fa-linkedin",
    label: "josh-pascual",
    href: "https://www.linkedin.com/in/josh-pascual/",
  },
  {
    icon: "fa-brands fa-github",
    label: "joshpas24",
    href: "https://github.com/joshpas24",
  },
  {
    icon: "fa-regular fa-file",
    label: "Download resume",
    href: "https://docs.google.com/document/d/1FAU2p8rl9nKo99RE8XkXtuzGTlOfC_q8I6qTc5-4g2s/export?format=pdf",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="relative py-28 px-6 bg-white/[0.015]">
      <div className="max-w-4xl mx-auto text-center">
        <Reveal>
          <span className="text-accent-light text-sm font-semibold tracking-widest uppercase">
            Contact
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-4">
            Let&apos;s work together
          </h2>
          <p className="text-zinc-400 text-base md:text-lg max-w-xl mx-auto mb-12">
            Open to full-stack engineering roles and interesting projects.
            Here&apos;s how to reach me.
          </p>
        </Reveal>

        <Reveal delay={100} className="grid sm:grid-cols-2 gap-4">
          {LINKS.map((link) => (
            <SpotlightCard
              key={link.label}
              as="a"
              href={link.href}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 p-4 rounded-xl bg-white/[0.03] border border-white/5 hover:border-accent/40 hover:bg-white/[0.06] text-zinc-300 hover:text-white transition-colors"
            >
              <span className="w-10 h-10 rounded-lg bg-accent/15 text-accent-light flex items-center justify-center shrink-0 text-lg">
                <i className={link.icon}></i>
              </span>
              <span className="text-sm md:text-base truncate">{link.label}</span>
            </SpotlightCard>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
